<button mat-raised-button ><!-- (click)="goToPage('health-form')" -->
  <i class="fab fa-wpforms"></i>
  Formulario
</button>
<button mat-raised-button [matMenuTriggerFor]="totalComission" class="demo-button" style="color: green;"><i class="fas fa-funnel-dollar"></i> {{getVJTotalComissions()}} €</button>
<mat-menu #totalComission="matMenu">
  <button mat-menu-item><i class="fas fa-funnel-dollar"></i>Omnibus  {{getOmnibusTotalComissions()}} €</button>
</mat-menu>
<button mat-icon-button (click)="loadContracts()" color="primary"><mat-icon>sync</mat-icon></button>

<div class="clients-view">
    <h2 class="title">Health Insurance Clients</h2>
    <div class="table-wrapper">
      <mat-spinner class="dark-button-spinner center" *ngIf="loading"></mat-spinner>
      <table class="clients-table" *ngIf="!loading && omnibusContracts.length>0">
        <thead>
          <tr>
            <th><i class="fas fa-user"></i> Client</th>
            <th><i class="fas fa-hand-holding-heart"></i> Service</th>
            <th><i class="fas fa-money-bill-wave"></i> Price</th>
            <th><i class="fas fa-calendar-alt"></i> Start Date</th>
            <th><i class="fas fa-calendar-check"></i> End Date</th>
            <th><i class="fas fa-check"></i>Active</th>
            <th><i class="fas fa-receipt"></i> Status</th>
            <th><i class="fas fa-receipt"></i> Billed</th>
            <th><i class="fas fa-receipt"></i> Status</th>
            <th><i class="fas fa-cogs"></i> Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Client Row 1 -->
          <tr *ngFor="let contract of getOmnibusClients()">
            <td>
              <div class="client-info">
                <img src="https://via.placeholder.com/40" alt="Client Photo" class="client-photo" />
                <span class="client-name">{{contract.name}} {{contract.lastname}}</span>
              </div>
            </td>
            <td style="text-align: left;">{{contract.service}}</td>
            <td>{{contract.price}} EUR</td>
            <td><app-date-render [date]="contract.startDate" [format]="'short'"></app-date-render></td>
            <td><app-date-render [date]="contract.endDate" [format]="'short'"></app-date-render></td>
            <td *ngIf="contract.paid=='0'"><span class="status pending">Pending</span></td>
            <td *ngIf="contract.paid=='1'"><span class="status paid">Paid</span></td>
            <td>
                <mat-chip-list>
                    <mat-chip class="valid" matTooltip='Vence: {{contract.endDate}}"' *ngIf="getMonthsRemaining(null,contract.endDate)>3"><i class="fas fa-laptop-medical"></i>{{getMonthsRemaining(null,contract.endDate)}} meses</mat-chip>
                    <mat-chip class="valid" matTooltip='Vence: {{contract.endDate}}"' *ngIf="getMonthsRemaining(null,contract.endDate)<=3 && getMonthsRemaining(null,contract.endDate)>0" color="accent"><i class="fas fa-laptop-medical"></i>{{getMonthsRemaining(null,contract.endDate)}} meses</mat-chip>
                    <mat-chip class="valid" matTooltip='Vence: {{contract.endDate}}"' *ngIf="getMonthsRemaining(null,contract.endDate)==0" style="color: indianred;"><i class="fas fa-laptop-medical"></i>Vencido</mat-chip>
                  </mat-chip-list>
            </td>
            <td *ngIf="contract.billed=='0'" style="color: orange;">Pending</td>
            <td *ngIf="contract.billed=='1'" style="color: green;">Paid</td>
            <td>({{contract.status}}){{getProcessStatus(contract.status)}}</td>
            <td>
              <button class="action-btn view">
                <i class="fas fa-eye"></i> View
              </button>
              <button class="action-btn edit" (click)="editContract(contract)">
                <i class="fas fa-edit"></i> Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</div>



  <div class="row row-sm">
    <div class="col-lg-12">

        <div class="card custom-card">
            <div class="card-body">

                  <mat-divider></mat-divider>
                  
                  <h4>Renovaciones</h4>
                  <ul>
                    <li>revisar la fecha con un mes de antelación</li>
                    <li>Si es para seguir estudiando, se debe pedir el seguro en las fechas de la nueva matrícula</li>
                    <li>Si es renovación por trabajo tenemos que notificar a Rai directamente</li>
                    <li>Si es por búsqueda de empleo ASISA lo gestiona cómo un seguro de estudiante</li>
                  </ul>
            
                  <mat-divider></mat-divider>
            
                  <h4>INDICACIONES PARA RELLENAR EL FORMULARIO</h4>
                  <p>
                    Formulario de solicitud del seguro médico
            
                  NIF/NIE : Ingresar el número de Pasaporte
                  Rellenar el formulario de Salud
            
                  NIF/NIE : Ingresar el número de Pasaporte
                  Talla: estatura en centímetros
            
                  OMNIBUS Seguros
            
                  https://www.omnibusbcn.com/servicios-y-soluciones/seguros-internacionales-para-estudiantes/seguro-de-salud/
            
                  Buscador de centros médicos: https://buscador.asisa.es/ (buscar los centros por código postal o por especialidad)
                  </p> 

                  <p>

Formulario de solicitud del seguro médico
NIF/NIE : Ingresar el número de Pasaporte
Rellenar el formulario de Salud
NIF/NIE : Ingresar el número de Pasaporte
Talla: estatura en centímetros

Tiene que tratarse de seguros de salud (no de viaje). Por ello, no es necesario que cubra repatriaciones y/o evacuaciones.
El seguro debe abarcar todos los riesgos cubiertos normalmente para nacionales (es decir, el catálogo de prestaciones del Sistema Nacional de Salud regulados en los artículos 7 y siguientes de la Ley 16/2003, de 28 de mayo, de cohesión y calidad del Sistema Nacional de Salud). Esta cobertura se debe mantener durante toda la vigencia de la autorización.
El seguro médico no debe tener carencia ni copago ni límite de cobertura, es decir, debe cubrir el 100% de los gastos médicos, hospitalarios y extra hospitalarios. Compañías españolas como Sanitas, Adeslas, Axa, etc. ofrecen coberturas del 100% de los gastos e ilimitadas. A pesar de lo anterior, en la medida en que cada póliza debe ser evaluada de manera individualizada, podrán aceptarse excepcionalmente seguros médicos de compañías extranjeras que establezcan límites máximos de cobertura si éstos cumplen con las demás características exigidas. 

                  </p>

                  <p>
                    https://www.omnibusbcn.com/servicios-y-soluciones/seguros-internacionales-para-estudiantes/seguro-de-salud/

Buscador de centros médicos: https://buscador.asisa.es/ (buscar los centros por código postal o por especialidad)


que los seguros comiencen siempre el día 1. 
que si es del día 15 o antes es del día 1
todos los seguros se hacen por año
Rellenar los formularios bien, con toda la información
si es por estudios, al cónyuge o al hijo se le puede sacar un certificado del seguro 


Renovaciones
revisar la fecha con un mes de antelación
si es para seguir estudiando, se debe pedir el seguro en las fechas de la nueva matrícula
si es renovación por trabajo tenemos que notificar a Rai directamente
si es por búsqueda de empleo ASISA lo gestiona cómo un seguro de estudiante



                  </p>
            </div>
        </div>
    </div>
</div>
